var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 20C9.80023 20 9.60023 19.94 9.42023 19.81L2.42023 14.81C2.07023 14.56 1.92023 14.1 2.05023 13.69C2.18023 13.28 2.57023 13 3.00023 13H21.0002C21.5502 13 22.0002 13.45 22.0002 14C22.0002 14.55 21.5502 15 21.0002 15H6.12023L10.5802 18.19C11.0302 18.51 11.1302 19.14 10.8102 19.58C10.6102 19.85 10.3102 20 10.0002 20Z",
    fill: "#27272A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.0001H3C2.45 10.0001 2 9.5501 2 9.0001C2 8.4501 2.45 8.0001 3 8.0001H17.88L13.42 4.8101C12.97 4.4901 12.87 3.8601 13.19 3.4201C13.51 2.9701 14.14 2.8701 14.59 3.1901L21.59 8.1901C21.94 8.4401 22.09 8.9001 21.96 9.3101C21.83 9.7201 21.44 10.0001 21.01 10.0001H21Z",
    fill: "#27272A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitch);
export default __webpack_public_path__ + "static/media/switch.58ccd8e12dcc35769054551861a10544.svg";
export { ForwardRef as ReactComponent };